class WishListItem {
  constructor(id, name, priceEach, priceEachWithFee, typ, quantity, priceTotal, priceTotalWithFee) {
    this.id = id;
    this.name = name;
    this.priceEach = priceEach;
    this.priceEachWithFee = priceEachWithFee;
    this.typ = typ;
    this.quantity = quantity;
    this.priceTotal = priceTotal;
    this.priceTotalWithFee = priceTotalWithFee;
  }
}

export default WishListItem;
